<template>
  <div v-if="!loading && !internalLoading" class="d-flex" style="position: relative;">
    <v-btn small :color="color" :class="showAltActions ? 'rounded-r-0' : null" style="text-transform: none;"
      @click="callAction(mainAction)">
      <v-icon v-if="mainAction.icon" size="20" v-text="mainAction.icon" class="mr-1" />
      {{ mainAction.text }}
    </v-btn>
    <template v-if="showAltActions">
      <v-divider vertical style="z-index: 1;"></v-divider>
      <slot name="alternate-actions">
        <v-menu :top="top" :bottom="!top" :offset-y="true" z-index="2000">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip top>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn v-bind="attrs" v-on="{ ...tooltip, ...menu }" small :color="color" class="rounded-l-0 px-2"
                  style="min-width: unset;" :loading="loading">
                  <v-icon size="20">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('servicesystem.common_objects.commonterms.other_actions') }}</span> 
            </v-tooltip>
          </template>
          <v-list class="pa-0">
            <v-hover v-for="(opt, index) in alternateActions" :key="index" v-slot="{ hover }">
              <v-list-item link dense class="px-3" @click="callAction(opt)">
                <v-list-item-icon class="mr-3">
                  <v-icon size="20" v-text="opt.icon" :color="hover ? (opt.color ? opt.color : 'black') : null" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="opt.text"
                    :class="(hover ? (opt.color ? opt.color : 'black') : '#5f5f5f') + '--text'" />
                </v-list-item-content>
              </v-list-item>
            </v-hover>
          </v-list>
        </v-menu>
      </slot>
    </template>
  </div>

  <v-btn v-else small :color="color" loading disabled>
  </v-btn>
</template>



<script>
export default {
  name: "AltOptionButton",
  props: {
    mainAction: {
      type: Object,
      required: true,
    },
    alternateActions: Array,
    loading: Boolean,
    color: {
      type: String,
      default: "primary darken-1",
    },
    top: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  mixins: [],

  data() {
    return {
      internalLoading: false,
    };
  },

  methods: {
    async callAction(action) {
      //console.log('action', action);
      this.internalLoading = true;
      await action.onClick();
      this.internalLoading = false;
    },
  },

  computed: {
    showAltActions() {
      return this.alternateSelectActionsSlotPopulated || (this.alternateActions && this.alternateActions.length > 0);
    },

    alternateSelectActionsSlotPopulated() {
      return !!this.$slots['alternate-actions'];
    },
  },

  watch: {},
};
</script>


<style scoped></style>